import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from "@angular/core";
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
	NgForm,
} from "@angular/forms";
import { MatSnackBar, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { ReplaySubject } from "rxjs";
import { SharedService } from "../../../../../../../app/shared/sharedServices/shared.service";
import { CommonHelper } from "../../../../../../../app/utilities/common.helper";
import { HEC_CONSTANTS } from "../../../../../../../app/utilities/constants";
import { decrypt } from "../../../../../../../app/utilities/utilityFunctions";
import { environment } from "../../../../../../../environments/environment";
import { PucaUploadDocumentService } from "./services/puca-upload-document.service";
import { SubjectService } from "./services/subject.service";
import { PucaFormService } from "../puca-form.service";
import { LoaderService } from "../../../../../../../../src/app/shared/sharedServices/loader.service";
import { HecResponse } from "../../../../../../../../src/app/shared/shared-interfaces/hecResponse";

@Component({
	selector: "kt-puca-upload-Documents",
	templateUrl: "./puca-upload-Documents.component.html",
	styleUrls: ["./puca-upload-Documents.component.scss"],
})
export class PucaUploadDocumentsComponent implements OnInit, OnChanges {
	public isCollapsed = true;
	public form: FormGroup;

	@Input("applicationId") applicationId: number;
	@Input("documentCategory") documentCategory: any;
	@Input("profileId") profileId: any;
	public degreeDetailsDocumentList: any;
	@ViewChild("fileDropRef", { static: false }) fileDropRef: ElementRef;
	@ViewChild("uploadDocumentForm", { static: false })
	uploadDocumentForm: NgForm;
	@Input() isAdmin: boolean = false;
	@Input() pucaApplication: any;
	files: any[] = [];
	public eduDropdownLevel: any = { qualificationLevel: [], programTitle: [] };
	private selectedFilePayload: any;
	private attachmentBase64: string;
	public isImageAlert: boolean = false;
	private fileExt: string = "pdf";
	private maxSize: number = 15360;
	public loader: boolean = false;
	public fileUploader: boolean = false;
	public fileName: string = "";
	selectedDocument: any;
	isDocumentSelected: boolean;
	isPucaApplication: boolean = false;
	get RESOURCE_CODES(): any {
		return HEC_CONSTANTS.SECTION_FIELD_RESOURCE_CODES;
	}
	@Input("allDropdowns") allDropdowns: any;
	@Input("rgaGrantConfigId") rgaGrantConfigId: any;
	@Input("childResources") childResources: any;
	@Input("applicationNumber") applicationNumber: any = 9;
	@Input("formViewType") formViewType: any;
	public viewTypes: any = HEC_CONSTANTS.APP_FORM_VIEWS;
	public filteredDocuments: ReplaySubject<any[]> = new ReplaySubject<any[]>(
		1
	);

	public documentDownloadList: Array<any> = [];
	public dropdownDocument: Array<any> = [];
	private loggedUser: any = null;
	private allDocumentsPresent: boolean = false;

	public currentDocumentList: Array<any> = [];

	public subjectSubscription: any;

	@Output() uploadUpdatedData = new EventEmitter();
	@Output() submitApplication = new EventEmitter();
	dropdownList: any = {};
	@Input("formType") formType: string;
	@ViewChild("documentDropDown", { static: false })
	documentDropDown: ElementRef;

	@Input() selectedIndexParent: number = 0;
	constructor(
		private cdr: ChangeDetectorRef,
		public _snackBar: MatSnackBar,
		private sharedService: SharedService,
		private uploadingService: PucaUploadDocumentService,
		private subjectService: SubjectService,
		private formBuilder: FormBuilder,
		private router: Router,
		private pucaFormService: PucaFormService,
		private loaderService: LoaderService,
		private matDialog: MatDialog
	) {
		this.pucaFormService.setNewPucaApplication.subscribe((v) => {
			this.pucaApplication = v;
			if (this.pucaApplication) {
				const pucaApplication = this.pucaApplication.pucaApplicationDto;
				console.log(this.pucaApplication);
				this.isPucaApplication = pucaApplication;
				this.applicationNumber = pucaApplication.id;
				this.getCurrentDocumentList();
			}
		});

		this.dropdownList["DocumentList"] =
			this.uploadingService.getUploadDocumentList();

		if (this.isPucaApplication) {
			for (let i = 0; i < this.dropdownList["DocumentList"].length; i++) {
				if (this.dropdownList["DocumentList"][i].label == "Passport") {
					this.dropdownList["DocumentList"][i].Mandatory = false;
				}
				if (
					this.dropdownList["DocumentList"][i].label ==
						"Relevant GRE or HAT Score Card" &&
					this.pucaApplication.pucaApplicationDto.categoryTypeId ==
						"32253"
				) {
					this.dropdownList["DocumentList"][i].Mandatory = false;
				}
			}
		}
		this.subjectSubscription = this.subjectService.tabReloadEvent.subscribe(
			(res) => {
				if (res == HEC_CONSTANTS.TAB_HEADINGS.UPLOAD_DOCUMENTS) {
					this.ngOnInit();
				}
			}
		);
	}
	async ngOnChanges(changes: SimpleChanges) {
		if (this.selectedIndexParent == 3) {
			if (this.pucaApplication) {
				if (this.pucaApplication.pucaApplicationDto) {
					this.loaderService.setValue(true);
					const res: HecResponse = await this.sharedService
						.getApplicationData(
							this.pucaApplication.pucaApplicationDto.id
						)
						.toPromise();
					if (res.code == 0) this.pucaApplication = res.result;
					this.loaderService.setValue(false);
				}
				console.log(this.pucaApplication);
				this.isRankLink =
					this.pucaApplication.pucaPreferencesDtoList[0].isQsSubjectRanking;
				console.log(this.isRankLink);
				this.dropdownDocument = !this.isRankLink
					? HEC_CONSTANTS.PUCA_NEW_DOC_UPLOAD_DROPDOWNS
					: HEC_CONSTANTS.PUCA_DOC_UPLOAD_DROPDOWNS;
				this.cdr.detectChanges();
				console.log(this.dropdownDocument);
				const pucaApplication = this.pucaApplication.pucaApplicationDto;
				console.log(pucaApplication);

				this.isPucaApplication = pucaApplication;

				this.applicationNumber = pucaApplication && pucaApplication.id;
				this.getCurrentDocumentList();

				this.dropdownList["DocumentList"] =
					this.uploadingService.getUploadDocumentList();

				//Upload University Rank List Screenshot on both cases
				//if (!this.isRankLink) {

				let obj: any = {
					label: "University Rank List Screenshot",
					value: 9,
					type: "PDF",
					Mandatory: true,
					maxSize: 512,
				};
				// this.dropdownList["DocumentList"].push(obj);
				this.cdr.detectChanges();
				console.log(this.dropdownList["DocumentList"]);
				//}
				// 	else if (this.isRankLink) {
				// 		this.dropdownList.forEach((value, index) => {
				// 			if (value.title == 'University Rank List Screenshot') this.dropdownList.splice(index, 1);
				// 		}
				// 	);

				// }

				if (this.isPucaApplication) {
					for (
						let i = 0;
						i < this.dropdownList["DocumentList"].length;
						i++
					) {
						if (
							this.dropdownList["DocumentList"][i].label ==
							"Passport"
						) {
							this.dropdownList["DocumentList"][i].Mandatory =
								false;
						}
						if (
							this.dropdownList["DocumentList"][i].label ==
								"Relevant GRE or HAT Score Card" &&
							this.pucaApplication.pucaApplicationDto
								.categoryTypeId == "32253"
						) {
							this.dropdownList["DocumentList"][i].Mandatory =
								false;
						}
					}
				}
				this.subjectSubscription =
					this.subjectService.tabReloadEvent.subscribe((res) => {
						if (
							res == HEC_CONSTANTS.TAB_HEADINGS.UPLOAD_DOCUMENTS
						) {
							this.ngOnInit();
						}
					});

				this.cdr.detectChanges();
			}
		}
	}
	isRankLink(isRankLink: any) {
		throw new Error("Method not implemented.");
	}

	public async getSelectedDocument(i) {
		this.selectedDocument = await this.dropdownList.DocumentList.find(
			(x) => x.value == i
		);
		this.isDocumentSelected = true;
		this.form.controls.documentType.setValue(this.selectedDocument.value);
		this.form.controls.documentIdFilter.setValue(
			this.selectedDocument.value
		);
	}
	async ngAfterViewInit() {
		if (this.pucaApplication) {
			const pucaApplication = this.pucaApplication.pucaApplicationDto;

			this.isPucaApplication = pucaApplication;

			this.applicationNumber = pucaApplication && pucaApplication.id;
			this.getCurrentDocumentList();
		}
	}
	ngOnInit() {
		window.scroll(0, 0);
		console.log("ngOnit puca upload doc");
		this.form = this.formBuilder.group({
			documentType: new FormControl(null, Validators.required),
			documentIdFilter: new FormControl(null),
		});
		this.loggedUser = JSON.parse(
			decrypt(localStorage.getItem("esp-profile-details"))
		);

		if (this.childResources) {
			this.documentDownloadList = this.childResources;
		}

		this.dropdownDocument = HEC_CONSTANTS.PUCA_DOC_UPLOAD_DROPDOWNS;
	}

	public downloadCertificate(section): void {
		let docType = null;
		if (section) {
			if (+section.resourceId == 50002) {
				docType = HEC_CONSTANTS.DOC_DOWNLOAD_TYPES.PROJECT_PROPOSAL;
			} else if (+section.resourceId == 50003) {
				docType = HEC_CONSTANTS.DOC_DOWNLOAD_TYPES.ENDORSEMENT;
			} else if (+section.resourceId == 50001) {
				docType =
					HEC_CONSTANTS.DOC_DOWNLOAD_TYPES.DECLARATION_CERTIFICATE;
			} else {
			}
		}
		let url = "/hec-rnd-rest/rest/rga/downloadStaticDoc/";
		window.open(url + docType + "/" + this.rgaGrantConfigId);
	}

	public shouldUploadDocument(): boolean {
		if (this.form) {
			return (
				this.form.value.documentType != undefined &&
				this.form.value.documentType != null &&
				this.form.value.documentType != ""
			);
		}
	}

	protected filterDocDropdown(dropdown): void {
		if (!dropdown) {
			return;
		}
		// get the search keyword
		let search = this.form.controls.documentIdFilter.value;
		if (!search) {
			this.filteredDocuments.next(dropdown.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		// filter the banks
		this.filteredDocuments.next(
			dropdown.filter((document) =>
				document.uploadDescription
					? document.uploadDescription.toLowerCase().indexOf(search) >
					  -1
					: null
			)
		);
		this.cdr.detectChanges();
	}

	onFileDropped($event) {
		this.prepareFilesList($event);
	}

	/**
	 * handle file from browsing
	 */
	fileBrowseHandler(files) {
		this.prepareFilesList(files);
	}

	/**
	 * Delete file from files list
	 * @param index (File index)
	 */
	deleteFile(index: number) {
		this.files.splice(index, 1);
	}

	/**
	 * Simulate the upload process
	 */
	uploadFilesSimulator(index: number) {
		setTimeout(() => {
			if (index === this.files.length) {
				return;
			} else {
				const progressInterval = setInterval(() => {
					if (this.files[index].progress === 100) {
						clearInterval(progressInterval);
						this.uploadFilesSimulator(index + 1);
						this.fileUploader = false;
						this.cdr.detectChanges();
					} else {
						this.files[index].progress += 5;
					}
				}, 200);
			}
		}, 1000);
	}

	/**
	 * Convert Files list to normal array list
	 * @param files (Files List)
	 */
	async prepareFilesList(e: Array<any>) {
		this.files = [];
		this.attachmentBase64 = null;
		if (e.length > 1) {
			return false;
		}
		let image = e[0];
		let test: File;
		let file = e[0];
		if (this.isValidFile(file)) {
			this.fileUploader = true;
			this.fileName = file.name;
			this.cdr.detectChanges();
			await this.setAttachmentsPayload(file);

			for (const item of e) {
				item.progress = 0;
				this.files.push(item);
				this.cdr.detectChanges();
			}

			this.uploadFilesSimulator(0);
		} else {
			e = undefined;
			file = undefined;
			this.fileDropRef.nativeElement.value = null;
		}
	}

	private isValidFile(file) {
		const extensions = this.fileExt.split(",").map(function (x) {
			return x.toLocaleLowerCase().trim();
		}); // array of extensions
		const ext = file.name.toLowerCase().split(".").pop() || file.name; // file extension
		const fileSizeinKB = file.size / 1024;

		if (extensions.indexOf(ext) === -1) {
			this.isImageAlert = true;
			this._snackBar.open(
				"Error in uploading " +
					file.name +
					" due to invalid file type.",
				"",
				{
					duration: 3500,
					panelClass: ["error-snackbar"],
				}
			);
			file = [];
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		} else if (file.name.match(/^[a-zA-Z-_( ')]*$/)) {
			this.isImageAlert = true;
			file = [];
			this._snackBar.open("Invalid File Name", "", {
				duration: 3500,
				panelClass: ["error-snackbar"],
			});
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		} else if (fileSizeinKB > this.maxSize) {
			file = [];
			this.isImageAlert = true;
			this._snackBar.open(
				file.name +
					" ( " +
					(fileSizeinKB / 1024).toFixed(2) +
					"MB )" +
					" exceeds file size limit of " +
					(this.maxSize / 1024).toFixed(2) +
					"MB.",
				"",
				{
					duration: 3500,
					panelClass: ["error-snackbar"],
				}
			);
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			return false;
		}
		return true;
	}

	private async setAttachmentsPayload(file) {
		this.attachmentBase64 = (
			await this.convertFileToBase64(file)
		).toString();
	}

	private getCurrentDocumentList(): void {
		let payload = {
			data: {
				applicationId: this.applicationNumber,
				processAcronym: "PUCA",
			},
		};
		this.getDocumentListService(payload);
	}

	private uploadAttachment() {
		const pucaApplication = this.pucaApplication.pucaApplicationDto;
		this.selectedFilePayload = "";
		this.selectedFilePayload = this.attachmentBase64;
		let found = this.selectedDocument;
		let count = 0;
		this.currentDocumentList.forEach((data) => {
			if (data.label == found.uploadDescription) {
				count++;
			}
		});
		let files = {
			data: {
				fileName: this.selectedDocument.label + ".pdf",

				base64: this.selectedFilePayload,
				processAcronym: "PUCA",
				applicationId: pucaApplication.id,
			},
		};
		//	count > 0 ? files.data.fileName = this.applicationNumber + '+' + found.uploadDescription.toString() + '+' + new Date().getTime() + '.' + this.fileName.split('.')[1] : files.data.fileName = this.applicationNumber + '+' + found.uploadDescription.toString() + '.' + this.fileName.split('.')[1];
		let payload = {
			// data: {
			// 	applicationId: pucaApplication.id,
			// 	addedBy:
			// 		this.loggedUser && this.loggedUser.principalName
			// 			? this.loggedUser.principalName
			// 			: null,
			// 	content: this.selectedFilePayload,
			// 	processAcronym: "PUCA",
			// 	category: "ApplicationForm",
			// 	title: this.selectedDocument.label,
			// 	comments: "Uploaded At " + new Date(),
			// },
			data: {
				applicationId: pucaApplication.id,
				base64: this.selectedFilePayload,
				processAcronym: "PUCA",
				fileName: this.selectedDocument.label + ".pdf",
			},
		};
		this.uploadDocumentService(payload);
	}

	public downloadOrdeleteDocument(row, pageState): void {
		if (row && row.title) {
			let payload = {
				data: {
					fileName:
						this.applicationNumber +
						"+" +
						row.title +
						(row.count != 0 ? "+" + row.count : "") +
						"." +
						row.fileExt,
					processAcronym: "RGA",
					applicationId: this.applicationNumber,
				},
			};
			if (pageState == 1) {
				this.downloadDocumentFileService(payload, row);
			} else if (pageState == 2) {
				this.sharedService
					.openCancelConfirmationDialog(
						"CONFIRMATION",
						"Are you sure you want to delete the selected document?"
					)
					.then((res) => {
						res ? this.deleteDocumentFileService(payload) : null;
					});
			} else {
			}
		} else {
			this.sharedService.showError(
				"Document Not Found",
				"OK",
				"error-snackbar"
			);
		}
	}

	public submitDocuments(): void {
		if (this.formType == "view") {
			this.pucaFormService.nextStep.next(true);
		}
		this.checkDocumentValidations();
	}

	private checkDocumentValidations(): void {
		let requiredDocuments = this.dropdownList.DocumentList;

		let uploadedDocuments = this.currentDocumentList;
		var pendingList = [];
		if (uploadedDocuments && uploadedDocuments.length) {
			for (let i = 0; i < requiredDocuments.length; i++) {
				if (this.isPucaApplication) {
					if (
						this.dropdownList["DocumentList"][i].label == "Passport"
					) {
						requiredDocuments[i].Mandatory = false;
					}
					if (
						this.dropdownList["DocumentList"][i].label ==
							"Relevant GRE or HAT Score Card" &&
						this.pucaApplication.pucaApplicationDto
							.categoryTypeId == "32253"
					) {
						requiredDocuments[i].Mandatory = false;
					}
				}
				if (
					requiredDocuments[i].Mandatory == true &&
					requiredDocuments[i].isUploaded == false
				) {
					pendingList.push(requiredDocuments[i].label);
				}
			}

			if (
				pendingList.length > 0 &&
				this.currentDocumentList &&
				this.currentDocumentList.length > 0
			) {
				let title = "PLEASE UPLOAD THE FOLLOWING DOCUMENTS ";
				//	this.sharedService.openConditionalErrors(title, pendingList);
				this.sharedService.showError(
					title + " " + pendingList.join(", "),
					"OK",
					"error-snackbar"
				);
			} else {
				this.pucaFormService.nextStep.next(true);
			}
		} else {
			this.sharedService.showError(
				"Please upload all the required documents",
				"OK",
				"error-snackbar"
			);
		}
	}

	public closeApplication(): void {
		this.router.navigate(["/applicant-dashboard"]);
	}

	private async getDocumentListService(payload) {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		try {
			const res: any = await this.uploadingService
				.getDocumentList(
					payload.data.processAcronym,
					payload.data.applicationId
				)
				.toPromise();
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.currentDocumentList = res.data;
				this.cdr.detectChanges();
				this.dropdownList.DocumentList.map(
					(element) => (element.isUploaded = false)
				);
				for (let i = 0; i < this.currentDocumentList.length; i++) {
					for (
						let j = 0;
						j < this.dropdownList.DocumentList.length;
						j++
					) {
						if (
							this.currentDocumentList[i] ==
							this.dropdownList.DocumentList[j].label + ".pdf"
						) {
							this.dropdownList.DocumentList[j].isUploaded = true;
						}
					}
				}

				// if (this.isRankLink) {
				// 	this.currentDocumentList.forEach((value, index) => {
				// 		if (value.title == 'University Rank List Screenshot') this.currentDocumentList.splice(index, 1);
				// 	});
				// }
				console.log(this.currentDocumentList);
				this.cdr.detectChanges();
			} else if (
				+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND
			) {
				this.currentDocumentList = [];
				this.cdr.detectChanges();
				this.dropdownDocument.map(
					(element) => (element.isUploaded = false)
				);
			} else {
				this.currentDocumentList = [];
				this.cdr.detectChanges();
				this.dropdownDocument.map(
					(element) => (element.isUploaded = false)
				);
			}
		} catch (error) {
			this.currentDocumentList = [];
			this.cdr.detectChanges();
			this.dropdownDocument.map(
				(element) => (element.isUploaded = false)
			);
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					"OK",
					"error-snackbar"
				);
			}
		}
	}

	private async uploadDocumentService(payload) {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		try {
			const res: any = await this.uploadingService
				.saveDocumentDetails(payload)
				.toPromise();
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.loaderService.setValue(false);
				let found = this.dropdownList.DocumentList.find((element) => {
					return element.value === this.form.value.documentType;
				});
				found.isUploaded = true;
				this.cdr.detectChanges();
				this.getCurrentDocumentList();
				this.isDocumentSelected = false;
				this.selectedDocument = false;
				this.cancelUpload();
				this.sharedService.showError(
					res.statusDescription,
					"OK",
					"success-snackbar"
				);
			} else {
				this.sharedService.showError(
					res.statusDescription,
					"OK",
					"error-snackbar"
				);
			}
		} catch (error) {
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					"OK",
					"error-snackbar"
				);
			}
		}
	}

	private async downloadDocumentFileService(payload, row) {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		try {
			window.open(
				environment.BASE_URL_PROFILE +
					"doc/downloadFile/" +
					payload.data.fileName +
					"/RGA/" +
					this.applicationNumber
			);
			this.subjectService.appDataLoading.next({ appDataLoading: false });
		} catch (error) {
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					"OK",
					"error-snackbar"
				);
			} else {
			}
		}
	}

	private async deleteDocumentFileService(payload) {
		this.subjectService.appDataLoading.next({ appDataLoading: true });
		try {
			const res: any = await this.uploadingService
				.deleteDocument(payload)
				.toPromise();
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.getCurrentDocumentList();
				this.sharedService.showError(
					res.statusDescription,
					"OK",
					"success-snackbar"
				);
			} else if (
				+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND
			) {
				this.sharedService.showError(
					res.statusDescription,
					"OK",
					"error-snackbar"
				);
			} else {
				this.sharedService.showError(
					res.statusDescription,
					"OK",
					"error-snackbar"
				);
			}
		} catch (error) {
			this.subjectService.appDataLoading.next({ appDataLoading: false });
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					"OK",
					"error-snackbar"
				);
			} else {
			}
		}
	}

	private convertFileToBase64(file): any {
		return new Promise((resolve, reject) => {
			CommonHelper.convertFileToBase64(file)
				.then((result) => {
					resolve(result);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	formatBytes(bytes, decimals) {
		if (bytes === 0) {
			return "0 Bytes";
		}
		const k = 1024;
		const dm = decimals <= 0 ? 0 : decimals || 2;
		const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return (
			parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
		);
	}

	public uploadDocuments() {
		this.loaderService.setValue(true);
		this.uploadAttachment();
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === "VALID") {
			return true;
		}
	}

	public getDocumentSelection(event) {
		for (let i = 0; i < this.degreeDetailsDocumentList.length; i++) {
			for (
				let j = 0;
				j < this.degreeDetailsDocumentList[i].docList.length;
				j++
			) {
				if (
					this.degreeDetailsDocumentList[i].docList[j]
						.documentTypeCodeId == event
				) {
					this.eduDropdownLevel.qualificationLevel.push({
						label: this.degreeDetailsDocumentList[i].degreeName,
						value: i,
					});
					this.eduDropdownLevel.programTitle.push({
						label: this.degreeDetailsDocumentList[i].subjectName,
						value: i,
					});
				}
			}
		}
		this.eduDropdownLevel.qualificationLevel = this.removeDup(
			this.eduDropdownLevel.qualificationLevel
		);
		this.eduDropdownLevel.programTitle = this.removeDup(
			this.eduDropdownLevel.programTitle
		);
	}

	public cancelUpload() {
		this.uploadUpdatedData.emit("cancel");
		this.form.reset();
		this.files = [];
		this.fileDropRef.nativeElement.value = null;
	}

	public removeDup(array) {
		const uniqueArray = array.filter((thing, index) => {
			const _thing = JSON.stringify(thing);
			return (
				index ===
				array.findIndex((obj) => {
					return JSON.stringify(obj) === _thing;
				})
			);
		});
		return uniqueArray;
	}
	public goBack() {
		this.pucaFormService.previousStep.next(true);
		this.cdr.detectChanges();
	}

	public async downloadDocument(file, index) {
		let payload = {
			data: {
				// documentId: file.documentId,
				// acronym: "PUCA",
				fileName: file,
				processAcronym: "PUCA",
				applicationId: this.pucaApplication.pucaApplicationDto.id,
			},
		};

		try {
			const res: any = await this.uploadingService
				.getAttachmentByDocumentId(payload)
				.toPromise();
			this.loaderService.setValue(false);
			CommonHelper.downloadFileFromBlob(
				res,
				"application/octet-stream",
				file + ".pdf"
			);
			this.cdr.detectChanges();
			this.cdr.markForCheck();
		} catch (error) {
			this.loaderService.setValue(false);
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					"OK",
					"error-snackbar"
				);
			} else {
			}
			this.cdr.detectChanges();
			this.cdr.markForCheck();
		}
	}

	private saveFile(base64, fileData, fileType) {
		const base_64 = base64.substring(base64.indexOf(",") + 1);
		const contentType = fileType;
		const fileName = fileData.fileName ? fileData.fileName : fileData.title;
		const fileExt =
			"." + contentType.substring(contentType.indexOf("/") + 1);

		const blob = CommonHelper.base64toBlob(base_64, contentType);
		const blobUrl = URL.createObjectURL(blob);

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
		} else {
			let a = document.createElement("a");
			a.href = blobUrl;
			a.download = fileName + fileExt;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
	}

	public ModalComponent(
		component,
		imageType,
		imageContent,
		backdropClass?,
		panelClass?
	) {
		const dialogRef = this.matDialog.open(component, {
			width: "70vw",
			height: "60vh",
			backdropClass: backdropClass,
			panelClass: panelClass,
			disableClose: true,
			autoFocus: false,
			data: { imageType: imageType, imageContent: imageContent },
		});
	}

	public deleteDocument(file, index) {
		let payload = {
			data: {
				applicationId: this.pucaApplication.pucaApplicationDto.id,
				processAcronym: "PUCA",
				fileName: file,
			},
		};
		this.loaderService.setValue(true);
		this.uploadingService
			.deleteDocument(payload)
			.subscribe((res: HecResponse) => {
				this.loaderService.setValue(false);
				this.getCurrentDocumentList();
			});
	}
}
